module.exports = __webpack_public_path__ + "static/media/teamwork.4d4ad816.svg";